import styled from 'styled-components';
import Spinner from '@carvana/loading-spinner';

export const LoadingSpinner = styled(Spinner)`
  background-color: #ffffff;
`;
